export default {
  "content": "<path d=\"M9.58 4.83L5 .25.42 4.83h9.16z\"/>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "width": "10",
    "height": "5",
    "fill": "#707070",
    "viewBox": "0 0 10 5"
  }
};